import { render, staticRenderFns } from "./PicturePage.vue?vue&type=template&id=6f3e92ec&scoped=true&"
import script from "./PicturePage.vue?vue&type=script&lang=js&"
export * from "./PicturePage.vue?vue&type=script&lang=js&"
import style0 from "./PicturePage.vue?vue&type=style&index=0&id=6f3e92ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e92ec",
  null
  
)

export default component.exports